import { injectable } from 'inversify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NotificationService from './NotificationService';
import DITYPES from '../config/di.types';
import DIContainer from '../config/di.container';
import { EErrorType } from '../common/enum/EErrorType';
import { ToasterModel } from '../common/model/ToasterModel';
import React from 'react';
import { SnackbarModel } from '../common/model/SnabarModel';
import EventEmitter from "../config/event.emitter";
import { snackBarClose, snackBarOpen } from '../common/constant';


@injectable()
export default class ToastrService {
    notificationService: NotificationService;
  
    constructor() {
        
        this.notificationService = DIContainer.get<NotificationService>(DITYPES.NotificationService);
        this.subscribeTosterNotification();
        this.subscribeSnackbarNotification();
        this.subscribeSnackbarNotificationClose();
    }

    subscribeTosterNotification() {
        this.notificationService.tosterNotification.subscribe((tosterObject: ToasterModel) => {
            let options: any;
            switch (tosterObject.Type) {
                case EErrorType.ERROR:
                    options = this.getToastOptions(EErrorType.ERROR);
                    toast.error(tosterObject.Message, options);
                   
                    break;
                case EErrorType.WARN:
                    options = this.getToastOptions(EErrorType.WARN);
                    toast.warn(tosterObject.Message, options);
                    break;
                case EErrorType.SUCCESS:
                    options = this.getToastOptions(EErrorType.SUCCESS);
                    toast.success(<div className="toaster-success-div"><i className="toaster-success-icon"></i>{tosterObject.Message}</div>, options);
                    break;
                case EErrorType.INFO:
                    options = this.getToastOptions(EErrorType.INFO);
                    toast.info(tosterObject.Message, options);
                    break;
                default:
                    break;
            }
        });
    }

    subscribeSnackbarNotification(){
        this.notificationService.snackbarNotification.subscribe((snackbarObject: SnackbarModel) => {          
            EventEmitter.emit(snackBarOpen, snackbarObject)
        })
    }

    subscribeSnackbarNotificationClose(){        
        this.notificationService.snackbarNotificationClose.subscribe(() => {          
            EventEmitter.emit(snackBarClose)
        })
    }

    getToastOptions(errorType: EErrorType) {
        let options = {
            position: errorType == EErrorType.ERROR ? toast.POSITION.TOP_CENTER : toast.POSITION.BOTTOM_LEFT,
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
        };
        return options;
    }
}
